import { buildFacetDesignOverrideLite, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverrideLite';
import {
  FDBodyText, FDDisplayText, FDHeadlineText, FDTitleText, FDSelectInput,
} from '@facet-wealth/design';
import { BigPicklistInput } from 'Packages/FacetDesign/Components/BigPicklistInput';
import { RadioGroupInput } from 'Packages/FacetDesign/Components/RadioGroupInput';
import { Richtext } from 'Packages/FacetDesign/Components/Richtext';

import { Text } from 'Packages/FacetDesign/Components/Text';
import { AgreementDetails } from 'Views/FreemiumEntry/HasRelationship/Content/Components/AgreementDetails';
import StripeInput from 'Organisms/StripeInput/StripeInput';
import {
  withComponentArray,
  withValueArray,
} from 'Helpers/MetaOverride';
import { FeedbackSelect } from 'Views/FreemiumEntry/HasRelationship/Content/Components/FeedbackSelect';
import { InfoBoxes } from 'Views/FreemiumEntry/HasRelationship/Content/Components/InfoBoxes';
import { Disclosure } from 'Views/FreemiumEntry/HasRelationship/Content/Components/Disclosure';
import fqResponseInsightUpgradeMetaOverrideSet
  from 'Views/FreemiumEntry/HasRelationship/Content/metaOverrides/fqResponseInsightUpgradeMetaOverrideSet';
import fqResponseInsightRequestConfirmationMetaOverrideSet
  from 'Views/FreemiumEntry/HasRelationship/Content/metaOverrides/fqResponseInsightRequestConfirmationMetaOverrideSet';
import { fqResponseContactAndInfluencerInformationMetaOverrideSet } from './fqResponseContactAndInfluencerInformation';
import { fqResponseInsightReferralIntroMetaOverrideSet } from './fqResponseInsightReferralIntro';
import { fqResponseContactAndQualificationInformationRefereeMetaOverrideSet } from './fqResponseContactAndQualificationInformationReferee';


const defaultMetaOverrideSet = buildFacetDesignOverrideLite()
  .nameOverride(['insightTitle', 'contactInfoTitle'], {
    _component: () => FDHeadlineText,
    _customProps: {
      size: 'sm',
      color: 'textSecondary',
      align: 'center',
    },
  }, overrideReadOnly)
  .nameOverride(['questionText'], {
    _component: () => Richtext,
    _customProps: {
      Component: FDHeadlineText,
      size: 'sm',
      color: 'textSecondary',
      align: 'center',
    },
  }, overrideReadOnly)
  .nameOverride(['title'], {
    _component: () => FDHeadlineText,
    _customProps: {
      size: 'lg',
      color: 'textSecondary',
      align: 'center',
    },
  }, overrideReadOnly)
  .nameOverride(['description'], {
    _component: () => FDBodyText,
    _customProps: {
      align: 'center',
    },
  }, overrideReadOnly)
  .nameOverride('feedback', {
    _component: () => FeedbackSelect,
  }, overrideReadOnly)
  .nameOverride('choice', {
    _component: () => BigPicklistInput,
  }, overrideReadOnly)
  .nameOverride('residencyConfirmation', {
    _component: () => RadioGroupInput,
    _customProps: {
      direction: 'row',
    },
  }, overrideReadOnly)
  .nameOverride(['descriptions'], {
    _component: () => withComponentArray(FDBodyText, 2),
    _customProps: { size: 'md' },
  }, overrideReadOnly)
  .nameOverride(['completedTitle'], {
    _component: () => FDHeadlineText,
    _customProps: { color: 'textSecondary' },
  }, overrideReadOnly)
  .nameOverride(['insightProductTitle'], {
    _component: () => FDHeadlineText,
    _customProps: {
      color: 'textSecondary',
      align: 'center',
    },
  }, overrideReadOnly)
  .nameOverride('infoBoxCollection', {
    _component: () => InfoBoxes,
  }, overrideReadOnly)
  .nameOverride('stripeToken', {
    _component: () => StripeInput,
    _customProps: { condensed: true },
  }, overrideReadOnly)
  .nameOverride(['dueToday'], {
    _component: () => Text,
    _customProps: { Component: FDHeadlineText, size: 'sm' },
  }, overrideReadOnly)
  .nameOverride('dueTodayText', {
    _component: () => Text,
    _customProps: { Component: FDHeadlineText, size: 'sm' },
  }, overrideReadOnly)
  .nameOverride('agreementDetails', {
    _component: () => AgreementDetails,
  }, overrideReadOnly)
  .nameOverride('emailVerificationStepTitle', {
    _component: () => FDDisplayText,
    _customProps: { size: 'md', align: 'center' },
  }, overrideReadOnly)
  .nameOverride('subtitle', {
    _component: () => withValueArray(FDHeadlineText),
    _customProps: { align: 'center', size: 'lg' },
  }, overrideReadOnly)
  .nameOverride(['age', 'householdIncome', 'estimatedSavings'], {
    _component: () => FDSelectInput,
    _customProps: { helperText: '' },
  }, overrideReadOnly)
  .nameOverride('subscriptHeader', {
    _component: () => FDTitleText,
    _customProps: { size: 'lg' },
  }, overrideReadOnly)
  .nameOverride('generalDisclosure', {
    _component: () => Disclosure,
    _customProps: {
      color: 'textPrimary',
      align: 'center',
    },
  }, overrideReadOnly)
  .nameOverride('formDisclosure', {
    _component: () => Disclosure,
    _customProps: {
      align: 'center',
    },
  }, overrideReadOnly);

export const getMetaOverrideSet = (type) => {
  switch (type) {
    case 'FQResponseInsightInfluencer':
    case 'FQResponseContactAndInfluencerInformation': {
      return fqResponseContactAndInfluencerInformationMetaOverrideSet;
    }
    case 'FQResponseInsightReferralIntro': {
      return fqResponseInsightReferralIntroMetaOverrideSet;
    }
    case 'FQResponseContactAndQualificationInformationReferee': {
      return fqResponseContactAndQualificationInformationRefereeMetaOverrideSet;
    }
    case 'FQResponseInsightUpgrade':
      return fqResponseInsightUpgradeMetaOverrideSet;
    case 'FQResponseInsightRequestConfirmation':
      return fqResponseInsightRequestConfirmationMetaOverrideSet;
    default:
      return defaultMetaOverrideSet;
  }
};
